import { FC, ReactNode } from 'react'

import {
  Text,
  BorderRadius4,
  CustomerLogo,
  GreyGrey10,
  GreyGrey70,
  GreyGrey90,
  Primary14ExtendedRegular,
  Primary14SemiBold,
  Center,
  Flex
} from '@sequencehq/core-components'
import { getLogoSrc } from 'Customer/index'

export const NotificationHeader: FC<{
  'data-testid': string
  customer?: Parameters<typeof getLogoSrc>[0] | null
  identifier?: string
  title?: ReactNode
  /**
   * Shown in the leading box when there is no customer to render a logo for
   * (e.g. an unresolved generic notification). Omit it to keep the empty box.
   */
  fallbackIcon?: ReactNode
}> = ({
  'data-testid': dataTestId,
  customer,
  identifier,
  title,
  fallbackIcon
}) => (
  <Flex alignItems="center" gap="8px" data-testid={dataTestId}>
    <Center
      borderRadius={BorderRadius4}
      overflow="hidden"
      boxSize="24px"
      background={GreyGrey10}
    >
      {customer ? (
        <CustomerLogo src={getLogoSrc(customer)} size={24} fallbackSize={16} />
      ) : (
        fallbackIcon
      )}
    </Center>
    {identifier && (
      <Text {...Primary14ExtendedRegular} color={GreyGrey70}>
        {identifier}
      </Text>
    )}
    {title && (
      <Text {...Primary14SemiBold} color={GreyGrey90}>
        {title}
      </Text>
    )}
  </Flex>
)
